import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Utility, { removeDelayedLoader, showDelayedLoader, deepClone } from "../../utility/Utility";
import { DKLabel, DKButton, DKCalendar, DKDataGrid } from "deskera-ui-library";
import DataGridHolderPayroll from "../common/DataGridHolderPayroll";
import { parseColumnConfig, AttendanceColumnConfig, AttendanceDrillDownColumnConfig, AttendanceDrillDownColumnName, parseVisibleColumnConfig } from "../configs/config";
import { fetchAttendance, selectAttendance, selectAttendanceColumnConfig } from "../../Redux/Slices/AttendanceSlice";
import AttendanceService from "../../services/AttendanceService";
import RouteManager from "../../managers/RouteManager";
import { COLUMN_CODE, TableManger, TABLES } from "../../managers/TableManger";
import moment from 'moment'
import { FORMAT } from "../../constants/Constant";
import UserManager from "../../managers/UserManager";
import { getUserProfilePic } from "../../managers/common/CommonUtil";
import calender from '../../assets/icons/white/date_range.svg'
import { TENANT, TenantService } from "../../managers/TenantManagerService";
import ApiConstants from "../../constants/ApiConstants";
import { useTranslation } from "react-i18next";
import { MODULE } from "../user-permissions/PermissionUtils";

const MyAttendance = (props) => {
    const { t, i18n } = useTranslation();

    const initialState = {
        columnData: [],
        rowData: [],
        originalData: [],
        filter: []
    };
    //State hooks
    const [refresh, setRefresh] = useState(false);
    const [attendance, setAttendance] = useState(initialState);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPageCount, setTotalPageCount] = useState(0);
    const [totalCount, setTotalCount] = useState(10);
    const initialYear = {
        toggle: false,
        startDate: moment(moment().format()).startOf('month'),
        endDate: moment(moment().format()).endOf('month'),
        defaultDate:false,
        hasError: false,
        errorMsg:'End date should not be less than Start date'
    }
    const [selectYear,setYear] = useState(initialYear)
    const [reload, setReload] = useState(false);
    //Store data selectors
    const dispatch = useDispatch();
    const attendanceData = useSelector(selectAttendance);
    const columnConfig = useSelector(selectAttendanceColumnConfig);
    const isActionEnabled = false;

    useEffect(() => {
        RouteManager.setPresenter({ props });
        /* API Calls Start */
        loadAttendance({});
        window.openSelectedLocation = function (latitude, longitude) {
          const link = ApiConstants.URL.GEO_LOCATION.VIEW_LOCATION(latitude, longitude);
          window.open(link, "_blank", "noopener");
        };
        /* API Calls End */
        return () => {
            window.openSelectedLocation= () => {};
            setAttendance(initialState)};
    }, [])

    useEffect(() => {
        if (!Utility.isEmpty(attendanceData)) {
            const { content, pageable,totalPages,totalElements } = attendanceData;
            const rowData = AttendanceColumnConfig(content, getExpandableView);
            let attendanceColumn = parseVisibleColumnConfig(parseColumnConfig(TableManger.getTableColumns(TABLES.ATTENDANCE)))
            const passingData = {
                columnData: deepClone(attendanceColumn),
                rowData,
                filter: [],
                originalData: rowData
            };
            setAttendance(passingData);
            setTotalPageCount(totalPages);
            setCurrentPage(pageable.pageNumber+1);
            setTotalCount(totalElements)
        }
    }, [attendanceData, reload]);

    const loadAttendance = async (config) => {
        try {
            const timeout = showDelayedLoader();
            AttendanceService.apiConfig = config;
            await dispatch(fetchAttendance());
            removeDelayedLoader(timeout);
        } catch (err) {
            console.error('Error loading contacts: ', err);
        }
    };
    const onDeleteContact = (data) => {
        const attendanceId = data[0].id;
        // ContactService.deleteContact(payrollId).then((res) => {
        //     showToast('Contact Deleted Successfully', TOAST_TYPE.WARNING);
        //     loadContacts({});
        // });
    };

    const onRowEdit = (data) => {
        // const contactList = contactsData['content'];
        // const contactId = data.rowData.id;
        // const contactData = contactList.filter(
        //     (contact) => contact.id === contactId
        // )[0];
        // if (contactData) {
        //     setEditableContact(contactData);
        //     setShowPopup(true);
        // }
    };
    const onSearch = (searchTerm) => {
        const config = {
            ...AttendanceService.apiConfig,
            Page: 0,
            SearchTerm: searchTerm
        };
        loadAttendance(config);
    };
    const newColumnAdded = (data) => {
        const columns = attendance.columnData;
        columns.push(data);
        setAttendance({ ...attendance, columnData: columns });
    };

    const onFilter = (updatedList, queries) => {
        // if (queries.length === 0) {
        //     setContacts({
        //         ...contacts,
        //         rowData: contacts.originalData,
        //         filter: queries
        //     });
        // } else {
        //     setContacts({
        //         ...contacts,
        //         rowData: updatedList,
        //         filter: queries
        //     });
        // }
    };

    const onRowAdd = (newRow) => {
        // if (newRow) {
        //     let updatedRowData = [...contacts.rowData];
        //     updatedRowData.unshift(newRow);
        //     setContacts({
        //         ...contacts,
        //         rowData: updatedRowData,
        //         originalData: updatedRowData
        //     });
        // }
    };

    const getExpandableView = (rowData) => {
        if (rowData.punchingLogs != null && rowData.punchingLogs.length > 0) {
            const rows = AttendanceDrillDownColumnConfig(rowData.punchingLogs);
            const columns = [];
            Object.values(COLUMN_CODE.ATTENDANCE_DRILL_DOWN).forEach(value => {
                columns.push({name: AttendanceDrillDownColumnName(value), key: value, type:'text', width: 385});
            });
            return (
              <div className="bg-gray2 parent-width">
                <DKDataGrid
                    allowBulkOperation={false}
                    allowColumnEdit={false}
                    allowColumnDelete={false}
                    allowColumnShift={false}
                    allowSearch={false}
                    allowFilter={false}
                    allowRowEdit={false}
                    allowExpand={false}
                    allowDataExport={false}
                    isActionEnabled={false}
                    onRowOpenBtnHidden={true}
                    isHeaderHidden={true}
                    columns={columns}
                    rows={rows} />
              </div>
            );
        } else {
            return (
                <div
                  className="p-h-xxl bg-gray1 parent-width column align-items-center justify-content-center"
                  style={{ height: 30 }}
                >
                  <DKLabel text="No data available" className="mt-r fs-m" />
                </div>
              );
        }
    }

    const updateRowExpanded = data => {
        let {rowIndex, rowData} = data;
        const updatedAttendance = {...attendance};
        updatedAttendance.rowData[rowIndex] = {...rowData};
        setAttendance(updatedAttendance);
    }

    return (
        <>
        <div className="parent-width parent-height">
        <DKLabel text={t("MY_ATTENDANCE_REPORT")} className="fw-m fs-l mb-m  ml-o" />
        <div className="row  ml-o">
            <div className="column">
            <DKButton
                className="bg-app text-white mr-r team-report-date"
                icon={calender}
                title={(selectYear.startDate !='' && selectYear.endDate !='') ? `${Utility.formatDate(moment(selectYear.startDate).format(FORMAT.DDMMYYYY), FORMAT.DDMMYYYY)} - ${Utility.formatDate(moment(selectYear.endDate).format(FORMAT.DDMMYYYY), FORMAT.DDMMYYYY)}`: `${Utility.formatDate(moment().startOf('month').format(FORMAT.DDMMYYYY), FORMAT.DDMMYYYY)} - ${Utility.formatDate(moment().endOf('month').format(FORMAT.DDMMYYYY), FORMAT.DDMMYYYY)}`}
                onClick={(value)=>{
                    setYear({
                        toggle: (selectYear.toggle) ? false : true,
                        startDate: selectYear.startDate,
                        endDate: selectYear.endDate,
                        defaultDate: true
                    })
                }}
              />

            </div>
            
        </div>
        {selectYear.hasError && <DKLabel className="text-red" text={selectYear.errorMsg}/>}
        <div className="">
        {selectYear.toggle && (
            <DKCalendar
            className="position-absolute border-m shadow-m bg-white z-index-1 mt-s"
            isDateRange={true}
            startDate={selectYear.startDate?new Date(selectYear.startDate):new Date()}
            endDate={selectYear.endDate? new Date(selectYear.endDate): new Date()}
            onClose={()=>{
                if(moment(selectYear.startDate).diff(selectYear.endDate) <= 0 || selectYear.endDate == null) {
                    setYear({
                        toggle: false,
                        startDate: selectYear.startDate,
                        endDate: selectYear.endDate,
                        defaultDate: false,
                        hasError: false
                    });
                } else {
                    setYear({
                        toggle: false,
                        startDate: selectYear.startDate,
                        endDate: selectYear.endDate,
                        defaultDate: false,
                        hasError: true,
                        errorMsg: "End date should not be less than Start date"
                    });
                }
            }}
            onSelectDate={(start, end) => {
                if(start && end) {
                    let startDate = start //timePeriod.defaultDate ? start : timePeriod.startDate;
                    let endDate = end//timePeriod.defaultDate ? timePeriod.endDate : end;
                    if(moment(startDate).diff(endDate) <= 0 || endDate == null) {
                        setYear({
                            toggle: false,
                            startDate: startDate,
                            endDate: endDate,
                            defaultDate: false,
                            hasError: false
                        });
            //             /* API Calls Start */
                        loadAttendance({
                            Limit: 20,
                            page: '0',
                            sort: 'clockIn',
                            sortDir: 'desc',
                            query: `clockIn>${moment(moment(startDate).format()).format('YYYY-MM-DD 00:00')},clockIn<${moment(moment(endDate).format()).format('YYYY-MM-DD 23:59')}`
                        });
                    } else {
                        setYear({
                            toggle: false,
                            startDate: startDate,
                            endDate: endDate,
                            defaultDate: false,
                            hasError: true,
                            errorMsg: "End date should not be less than Start date"
                        });
                    }
                }
            }}

            />
            )}
        </div>
        <div className="row " style={{
            height:"90%"
        }}>
        <div className="column parent-width flex-1 parent-height">
                <div className="column parent-width mb-s position-relative flex-1 ">
                <div className="column  parent-width pt-m pl-o"
                style={{marginBottom:'-8px',width: "-webkit-fill-available"}}>
                    <div className="column parent-width pt-s pb-s pl-s pr-s border-box position-relative flex-1 bg-white border-radius-s">
                    <div className="row">
                        <div className="column">
                        <img className="mr-s border-radius-l" style={{height:32, width:32}} src={getUserProfilePic({
                                name: UserManager.getUserName(),
                                backgroundColor: '#001F42',
                                textColor: '#FFF',
                                font: 'bold 24px sans-serif',
                                height: 72,
                                width: 72,
                            })}/>
                        </div>
                        <div className="column">
                            <h4 className="mt-s " style={{marginBottom:'0px'}}>{UserManager.getUserName()}</h4>
                            <p className="mb-s text-gray fw-m" style={{marginTop:'0px'}}>{TenantService.get(TENANT.DESIGNATION)}</p>
                        </div>
                    </div>
                    </div>
                </div>
                    <DataGridHolderPayroll
                        tableName={TABLES.ATTENDANCE}
                        displayTableName={" "}
                        allowColumnEdit={false}
                        allowColumnDelete={false}
                        allowColumnShift={false}
                        allowSearch={false}
                        allowFilter={false}
                        allowExpand={true}
                        onRowDelete={onDeleteContact}
                        onRowEdit={(data) => {
                            onRowEdit(data);
                        }}
                        onRowExpand={(data) => {updateRowExpanded(data);} }
                        refresh={refresh}
                        allowDataExport={false}
                        gridData={attendance}
                        onSearch={onSearch}
                        onColumnAdd={newColumnAdded}
                        onFilter={onFilter}
                        filter={attendance.filter}
                        onRowAdd={onRowAdd}
                        onPaginationClick={(requestedPageNumber) => {
                            const config = {
                                ...AttendanceService.apiConfig,
                                page: requestedPageNumber - 1
                            };
                            loadAttendance(config);
                        }}
                        currentPage={currentPage}
                        totalPageCount={totalPageCount}
                        isActionEnabled={isActionEnabled}
                        onRowOpenBtnHidden={true}
                        isHeaderHidden={true}
                        onColumnShift={(data)=> setReload(!reload)}
                        module={MODULE.MY_ATTENDANCE}
                    />
                </div>
                {/* {showPopup && (
                    <PopupWrapper
                        clickAction={catchClicks}
                        type={POPUP_TYPE.POPUP}
                        title={'Update Contact'}
                        btnList={popupBtnConfig}
                    >
                        <AddContact
                            populateFormData={editableContact}
                            passingInteraction={(callback: CallBackPayloadType) => {
                                parentChildInteraction(callback);
                            }}
                        />
                    </PopupWrapper>
                )} */}
            </div>
        </div>
        </div>
        </>
    )
}

export default MyAttendance;
